import { transformScientificNum } from '@utils/widget';
export const SgaProto = {
  defaults: ['buyer', 'target', 'combined'],
  others: ['comp1', 'comp2', 'comp3'],
  pctFields: ['smPct', 'gaPct', 'rdPct', 'sgaPct'],
  mnFields: ['revenue'],
};

const EMPTY_SGA_RRCORD = {
  companyName: '',
  revenue: null,
  smPct: null,
  gaPct: null,
  rdPct: null,
  sgaPct: null,
};

export const isEmptyValue = (v) =>
  typeof v === 'undefined' || v === '' || v == null;

export const pctFormatter = (value) => {
  if (isEmptyValue(value)) {
    return null;
  }
  return (value * 100).toFixed(1);
};

export const mnFormatter = (value) => {
  if (isEmptyValue(value)) {
    return null;
  }
  const res = parseFloat(value, 10) / 1e6;
  const abs = Math.abs(res);
  if (abs !== 0 && abs < 1) {
    return res.toFixed(1);
  }
  return res.toFixed(0);
};

export const formatRecordToRender = (record, index) => {
  const result = {};

  result.companyName = record.companyName;

  SgaProto.mnFields.forEach((key) => {
    result[key] = mnFormatter(record[key]);
  });

  SgaProto.pctFields.forEach((key) => {
    result[key] = pctFormatter(record[key]);
  });
  // To remove warnings
  if (index) {
    result.key = index;
  }
  return result;
};

export const formatModifiedRecordToSend = (record) => {
  const result = {};

  result.companyName = record.companyName || '';

  SgaProto.mnFields.forEach((key) => {
    if (isEmptyValue(record[key])) {
      result[key] = null;
      return;
    }
    result[key] = transformScientificNum(record[key] * 1e6);
  });

  SgaProto.pctFields.forEach((key) => {
    result[key] = isEmptyValue(record[key]) ? null : record[key] / 100;
  });

  return result;
};

export const fillAndFormatRecords =
  (template) =>
  (array = []) =>
    template
      .map((_, i) => array[i] || EMPTY_SGA_RRCORD)
      .map(formatRecordToRender);

export const buildUnEditableRecords = fillAndFormatRecords(SgaProto.defaults);

export const buildEditableRecords = fillAndFormatRecords(SgaProto.others);

export const formatSGADataToRecords = (sgaRawData = {}) => {
  const { defaults, others, competitors } = sgaRawData || {};

  if (!defaults || defaults.length === 0) {
    return [];
  }

  const moveDefaultToTail = (a, b) => {
    const isDefault = (record) => record.companyName?.includes('Comp');
    if (!isDefault(a) && isDefault(b)) {
      return -1;
    }
    return 0;
  };

  const newOthers = [...others, ...competitors]
    .sort(moveDefaultToTail)
    .filter(
      (e, i, a) =>
        a.findIndex((ele) => ele.companyName === e.companyName) === i,
    )
    .slice(0, 3);

  return Array.prototype.concat(
    [],
    buildUnEditableRecords(defaults),
    buildEditableRecords(newOthers),
  );
};

export const isToReplaceRecords = (sgaRaw = {}) =>
  typeof sgaRaw.defaults == 'undefined' && sgaRaw.others instanceof Array;

export const isNotJunk = (record) => {
  if (isEmptyValue(record)) {
    return false;
  }
  return Object.values(record).some((v) => !isEmptyValue(v));
};
